import React from 'react';

const BrandLogos = () => {
  // Logo images from public/images/logos folder
  const brandLogos = [
    { name: 'Amazon', logo: '/images/logos/amazon.svg' },
    { name: 'Axis', logo: '/images/logos/axis.png' },
    { name: 'LPU', logo: '/images/logos/lpu.png' },
    { name: 'Odoo', logo: '/images/logos/odoo.png' },
    { name: 'Perplexity', logo: '/images/logos/perplexity.png' },
    { name: 'Policy Bazar', logo: '/images/logos/policybazar.png' },
    { name: 'PW', logo: '/images/logos/physicswallah.png' },
    { name: 'Seekho', logo: '/images/logos/seekho.png' },
    { name: 'Shadowfax', logo: '/images/logos/shadowfax.png' },
    { name: 'Slice', logo: '/images/logos/slice.svg' },
    { name: 'Stockgrow', logo: '/images/logos/stockgrow.png' },
    { name: 'Tata Motors', logo: '/images/logos/tata motors.png' }
  ];

  return (
    <section className="bg-white py-16 px-6 overflow-hidden">
      <div className="mx-auto max-w-7xl">
        <p className="text-center text-gray-600 mb-12 font-inter">
          Many brands have already trusted Lxdia
        </p>

        {/* Infinite Scrolling Logos */}
        <div className="relative">
          {/* Gradient overlays for smooth edges */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10"></div>
          
          <div className="flex overflow-hidden items-center group">
            <div className="flex animate-scroll items-center whitespace-nowrap">
              {/* Repeat logos 3 times for seamless infinite scroll */}
              {[...Array(3)].map((_, setIndex) => (
                <React.Fragment key={setIndex}>
                  {brandLogos.map((brand, index) => {
                    const isLargerLogo = ['Policy Bazar', 'PW', 'Slice', 'Tata Motors'].includes(brand.name);
                    const isMediumLogo = ['Shadowfax'].includes(brand.name);
                    return (
                      <div
                        key={`${setIndex}-${index}`}
                        className="flex-shrink-0 mx-6 md:mx-10 hover:scale-110 transition-all duration-300 flex items-center justify-center"
                        style={{ minWidth: '100px', height: '60px' }}
                      >
                        <img
                          src={brand.logo}
                          alt={brand.name}
                          className={`${isLargerLogo ? 'h-14 md:h-16' : isMediumLogo ? 'h-10 md:h-12' : 'h-8 md:h-10'} w-auto object-contain max-w-[140px]`}
                        />
                      </div>
                    );
                  })}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandLogos;
